module.exports = __webpack_public_path__ + "img/foul_adelante.e86198da.gif";